import { render, staticRenderFns } from "./CRPageModal.vue?vue&type=template&id=61de3b84&scoped=true&"
import script from "./CRPageModal.vue?vue&type=script&lang=js&"
export * from "./CRPageModal.vue?vue&type=script&lang=js&"
import style0 from "./CRPageModal.vue?vue&type=style&index=0&id=61de3b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de3b84",
  null
  
)

export default component.exports